import * as React from 'react';
import ArrowRotateRightOutlined from './arrow-rotate-right-outlined';
import ArrowRotateRightFilled from './arrow-rotate-right-filled';
import type { IconCombinedProps } from './types';
const ArrowRotateRightCombined = React.forwardRef<SVGSVGElement, IconCombinedProps>((props, ref) => {
  const {
    isFocused,
    isHovered,
    isPressed,
    ...rest
  } = props;
  if (isFocused || isHovered || isPressed) {
    return <ArrowRotateRightFilled ref={ref} {...rest} />;
  }
  return <ArrowRotateRightOutlined ref={ref} {...rest} />;
});
export default ArrowRotateRightCombined;